"use client";

import { useState, useEffect, useCallback } from "react";

interface UseCountdownReturn {
  seconds: number;
  isActive: boolean;
  start: (duration?: number) => void;
  reset: () => void;
}

export function useCountdown(initialSeconds = 30): UseCountdownReturn {
  const [seconds, setSeconds] = useState(0);
  const [isActive, setIsActive] = useState(false);

  useEffect(() => {
    if (!isActive || seconds <= 0) return;

    const id = setInterval(() => {
      setSeconds((s) => {
        if (s <= 1) {
          setIsActive(false);
          return 0;
        }
        return s - 1;
      });
    }, 1000);

    return () => clearInterval(id);
  }, [isActive, seconds]);

  const start = useCallback(
    (duration = initialSeconds) => {
      setSeconds(duration);
      setIsActive(true);
    },
    [initialSeconds]
  );

  const reset = useCallback(() => {
    setSeconds(0);
    setIsActive(false);
  }, []);

  return { seconds, isActive, start, reset };
}
